'use es6';

import PropTypes from 'prop-types';
import text from 'I18n/utils/unescapedText';
import AutofillHoneypot from '../component/AutofillHoneypot';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LANG_ROUTE = 'InboxConnectUtils.genericInboxForm';
const AccountSettings = ({
  onFieldChange,
  isEmailFieldDisabled,
  isPasswordFieldDisabled,
  validationMessages,
  value
}) => /*#__PURE__*/_jsxs(View, {
  textAlign: "start",
  marginBlockStart: "400",
  children: [/*#__PURE__*/_jsx(AutofillHoneypot, {}), /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${LANG_ROUTE}.emailLabel`
    }),
    required: true,
    error: Boolean(validationMessages.email),
    validationMessage: !!validationMessages.email && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: validationMessages.email
    }),
    children: /*#__PURE__*/_jsx(TextInput, {
      name: "account-email",
      "data-test-id": "account-email",
      autoComplete: `imapemail-no-autocomplete-${Math.random()}`,
      disabled: isEmailFieldDisabled,
      placeholder: text(`${LANG_ROUTE}.emailPlaceholder`),
      defaultValue: value.email,
      onChange: evt => {
        onFieldChange(evt, 'email');
      }
    })
  }), /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${LANG_ROUTE}.passwordLabel`
    }),
    required: true,
    error: Boolean(validationMessages.password),
    validationMessage: !!validationMessages.password && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: validationMessages.password
    }),
    children: /*#__PURE__*/_jsx(TextInput, {
      type: "password",
      name: "account-password",
      "data-test-id": "account-password",
      autoComplete: `imappass-no-autocomplete-${Math.random()}`,
      disabled: isPasswordFieldDisabled,
      placeholder: text(`${LANG_ROUTE}.passwordPlaceholder`),
      onChange: evt => {
        onFieldChange(evt, 'password');
      },
      value: value.password
    })
  })]
});
AccountSettings.propTypes = {
  onFieldChange: PropTypes.func.isRequired,
  isEmailFieldDisabled: PropTypes.bool.isRequired,
  isPasswordFieldDisabled: PropTypes.bool.isRequired,
  validationMessages: PropTypes.object.isRequired,
  value: PropTypes.any.isRequired
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
AccountSettings.defaultProps = {
  isEmailFieldDisabled: false,
  isPasswordFieldDisabled: false
};
export default AccountSettings;